export const propMiscModals = {
  policia: {
    title: "Registrar datos",
    heading: "Registra los datos de las autoridades competentes",
    subtitle:
      "Sincroniza de forma automática los check-ins de tu propiedad con las autoridades",
    entityLabel: "Nombre de la entidad",
    entityPlaceholder: "Selecciona un entidad",
    userLabel: "Usuario",
    passwordLabel: "Contraseña",
    accessError:
      "Verifica los datos de acceso, se recomienda no intentar más de tres veces o puedes bloquear tu usuario.",
    validateBtn: "Validar",
    saveBtn: "Guardar datos",
    entityRequired: "La entidad es requerida",
    usernameRequired: "El nombre de usuario es requerido",
    passwordRequired: "Debe ingresar la contraseña",
    validateError: "Error al intentar validar los datos",
    saveError: "Error al ingresar los datos de la policía migratoria",
  },
  upgrade: {
    heading: "Actualiza tu plan para seguir creando propiedades",
    message:
      "\"¡Hola! hemos notado que has superado el límite de propiedades permitidas en tu plan actual.",
    button: "Actualizar plan",
  },
};
